import { defineComponent as _defineComponent } from 'vue'
import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, Fragment as _Fragment, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "app-notification__icon" }
const _hoisted_2 = { class: "app-notification__content" }
const _hoisted_3 = {
  key: 0,
  class: "app-notification__title"
}
const _hoisted_4 = { class: "app-notification__message" }
const _hoisted_5 = {
  key: 1,
  class: "app-notification__actions"
}

import { computed, ref } from 'vue';
// @ts-ignore
import { onMounted, onUnmounted } from 'vue';

// Composants d'icônes
import CheckCircleIcon from './icons/CheckCircleIcon.vue';
import ExclamationTriangleIcon from './icons/ExclamationTriangleIcon.vue';
import XCircleIcon from './icons/XCircleIcon.vue';
import InformationCircleIcon from './icons/InformationCircleIcon.vue';
import type { ToastNotification, ToastAction, ToastType } from '@/types';

interface Props {
  notification: ToastNotification;
}

interface Emits {
  (e: 'close', notificationId?: number): void;
  (e: 'action', action: ToastAction): void;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'AppNotification',
  props: {
    notification: {}
  },
  emits: ["close", "action"],
  setup(__props: any, { emit: __emit }) {

/// <reference types="vue" />
// @ts-ignore
/// <reference types="vue" />
// @ts-ignore
const props = __props;
const emit = __emit;

// Gestion de la barre de progression
const progress = ref<number>(100);
const progressInterval = ref<NodeJS.Timeout | null>(null);

// Classes CSS dynamiques
const notificationClasses = computed(() => [
  `app-notification--${props.notification.type}`,
  {
    'app-notification--with-title': props.notification.title,
    'app-notification--with-actions': props.notification.action,
    'app-notification--closable': props.notification.closable
  }
]);

// Composant d'icône basé sur le type
const iconComponent = computed(() => {
  const iconMap: Record<string, any> = {
    success: CheckCircleIcon,
    error: XCircleIcon,
    warning: ExclamationTriangleIcon,
    info: InformationCircleIcon
  };
  return iconMap[props.notification.type] || InformationCircleIcon;
});

// Style de la barre de progression
const progressStyle = computed(() => ({
  width: `${progress.value}%`
}));

// Gestionnaires d'événements
const handleAction = (): void => {
  if (props.notification.action?.callback) {
    props.notification.action.callback();
  }
  emit('action', props.notification.action);
  emit('close');
};

const handleConfirm = (): void => {
  if (props.notification.action?.onConfirm) {
    props.notification.action.onConfirm();
  }
  emit('close');
};

const handleCancel = (): void => {
  if (props.notification.action?.onCancel) {
    props.notification.action.onCancel();
  }
  emit('close');
};

const handleClose = (): void => {
  emit('close');
};

// Gestion du timer de progression
const startProgressTimer = (): void => {
  if (props.notification.duration <= 0) return;

  const startTime = Date.now();
  const duration = props.notification.duration;

  progressInterval.value = setInterval(() => {
    const elapsed = Date.now() - startTime;
    const remaining = Math.max(0, duration - elapsed);
    progress.value = (remaining / duration) * 100;

    if (remaining <= 0) {
      if (progressInterval.value) {
        clearInterval(progressInterval.value);
      }
      emit('close');
    }
  }, 50);
};

// Lifecycle
onMounted(() => {
  startProgressTimer();
});

onUnmounted(() => {
  if (progressInterval.value) {
    clearInterval(progressInterval.value);
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["app-notification", notificationClasses.value])
  }, [
    _createElementVNode("div", _hoisted_1, [
      (_openBlock(), _createBlock(_resolveDynamicComponent(iconComponent.value)))
    ]),
    _createElementVNode("div", _hoisted_2, [
      (_ctx.notification.title)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.notification.title), 1))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.notification.message), 1),
      (_ctx.notification.action)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            (_ctx.notification.action.type !== 'confirm')
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  onClick: _withModifiers(handleAction, ["stop"]),
                  class: "app-notification__action-btn app-notification__action-btn--primary"
                }, _toDisplayString(_ctx.notification.action.label || _ctx.$t('common.action')), 1))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createElementVNode("button", {
                    onClick: _withModifiers(handleConfirm, ["stop"]),
                    class: "app-notification__action-btn app-notification__action-btn--confirm"
                  }, _toDisplayString(_ctx.$t('common.yes')), 1),
                  _createElementVNode("button", {
                    onClick: _withModifiers(handleCancel, ["stop"]),
                    class: "app-notification__action-btn app-notification__action-btn--cancel"
                  }, _toDisplayString(_ctx.$t('common.no')), 1)
                ], 64))
          ]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.notification.closable !== false)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          onClick: _withModifiers(handleClose, ["stop"]),
          class: "app-notification__close",
          "aria-label": "Fermer",
          type: "button"
        }, [...(_cache[0] || (_cache[0] = [
          _createElementVNode("i", { class: "fas fa-times" }, null, -1)
        ]))]))
      : _createCommentVNode("", true),
    (_ctx.notification.duration > 0)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "app-notification__progress",
          style: _normalizeStyle(progressStyle.value)
        }, null, 4))
      : _createCommentVNode("", true)
  ], 2))
}
}

})